// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"211b74a6","390":"a6972959","414":"cc456023","481":"471354b7","702":"d1eddc04","833":"4ac10e4c","975":"d1eddc04"}[chunkId] + ".chunk.css";
};